export default function hasRedzoneEmail(email: string): boolean {
  return email?.toLocaleLowerCase().endsWith('@redzone.com');
}
